import React from "react";
import { Link } from "react-router-dom";
import "./NewFooter.css";

const getTomorrowDate = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  return tomorrow.toISOString().split("T")[0];
};

const tomorrowDate = getTomorrowDate();

const domesticRoutes = [
  { ori: "Delhi", dest: "Goa", code: "GOI", org: "DEL" },
  { ori: "Mumbai", dest: "Delhi", code: "DEL", org: "BOM" },
  { ori: "Delhi", dest: "Mumbai", code: "BOM", org: "DEL" },
  { ori: "Bangalore", dest: "Delhi", code: "DEL", org: "BLR" },
  { ori: "Mumbai", dest: "Goa", code: "GOI", org: "BOM" },
];

const internationalRoutes = [
  { ori: "Delhi", dest: "Dubai", code: "DXB", org: "DEL" },
  { ori: "Delhi", dest: "London", code: "LHR", org: "DEL" },
  { ori: "Delhi", dest: "Toronto", code: "YYZ", org: "DEL" },
  { ori: "Mumbai", dest: "Paris", code: "CDG", org: "BOM" },
  { ori: "Delhi", dest: "Singapore", code: "SIN", org: "DEL" },
];

const NewFooter = () => {
  return (
    <footer className="vp-footer">
      {/* TOP */}
      <div className="vp-footer-top">
        <div className="vp-footer-brand">
          <h3>VolarPro</h3>
          <p>
            IATA-accredited travel agency based in Saudi Arabia, offering global
            flight deals with trusted airlines.
          </p>
        </div>

        <div className="vp-footer-social">
          <span>Connect with us</span>
          <div className="vp-social-icons">
            <a href="#" aria-label="Facebook">
              <i className="fab fa-facebook-f" />
            </a>
            <a href="#" aria-label="Instagram">
              <i className="fab fa-instagram" />
            </a>
          </div>
        </div>
      </div>

      {/* LINKS */}
      <div className="vp-footer-links">
        <div className="vp-footer-col">
          <h4>Company</h4>
          <ul>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/offers">Offers</Link></li>
          </ul>
        </div>

        <div className="vp-footer-col">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
          </ul>
        </div>

        {/* Domestic Flights */}
        <div className="vp-footer-col wide">
          <h4>Popular Domestic Flights</h4>
          <ul className="two-col">
            {domesticRoutes.map((item, i) => (
              <li key={i}>
                <Link
                  to={`/flightList/dest_${item.code}*org_${item.org}*dep_${tomorrowDate}*arr_${tomorrowDate}*px_1-0-0*jt_1*cbn_2`}
                >
                  {item.ori} to {item.dest} Flights
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* International Flights */}
        <div className="vp-footer-col wide">
          <h4>Popular International Flights</h4>
          <ul className="two-col">
            {internationalRoutes.map((item, i) => (
              <li key={i}>
                <Link
                  to={`/flightList/dest_${item.code}*org_${item.org}*dep_${tomorrowDate}*arr_${tomorrowDate}*px_1-0-0*jt_1*cbn_2`}
                >
                  {item.ori} to {item.dest} Flights
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* PAYMENT */}
      <div className="vp-footer-payments">
        <img
          src="https://c.fareportal.com/vd/coa/travel/r6/images/footer-logo-desktop.webp"
          alt="Payment Partners"
        />
      </div>

      {/* BOTTOM */}
      <div className="vp-footer-bottom">
        <p>© 2025 volarpro.com · All rights reserved · IATA Accredited</p>
      </div>
    </footer>
  );
};

export default NewFooter;